import { render, staticRenderFns } from "./LotteryNotification.vue?vue&type=template&id=3006d48f&"
import script from "./LotteryNotification.vue?vue&type=script&lang=js&"
export * from "./LotteryNotification.vue?vue&type=script&lang=js&"
import style0 from "./LotteryNotification.vue?vue&type=style&index=0&id=3006d48f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports